import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';

const HEADERS = {};

@Injectable()
export class ReportService {

  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public getYears(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.f_get_book_year}/${data.value}`, httpRequesthandler);
  }

  public getFormat(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.get_ledger_format}/${data.ledger}/${data.year}`, httpRequesthandler);
  }

  public getLiteral(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ReportService.ENV.environment.API.get_literals_by, data, httpRequesthandler);
  }

  public repConceptsRange(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ReportService.ENV.environment.API.rep_concepts_range, data, httpRequesthandler);
  }

  public repFormatConcepts(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ReportService.ENV.environment.API.rep_format_concepts, data, httpRequesthandler);
  }

  public getYearsLiterals(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.get_ledger_year_literals}/${data.value}`, httpRequesthandler);
  }

  public getFormatConcept(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.f_get_format_concept}/${data}`, httpRequesthandler);
  }

  public getThirdpartyYears(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.f_get_thirdparty_years}/${data}`, httpRequesthandler);
  }

  public repThirdparty(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${ReportService.ENV.environment.API.f_rep_thirdparty}/${data.p_year}/${data.p_ledger_id}`, httpRequesthandler);
  }

  public repLitAccount(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${ReportService.ENV.environment.API.f_rep_lit_account}`, data, httpRequesthandler);
  }

  public copyFormats(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${ReportService.ENV.environment.API.f_format_copy}`, data, httpRequesthandler);
  }

  public repValidationXml(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${ReportService.ENV.environment.API.f_rep_validation_xml}`, data, httpRequesthandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report/report.service.ts